import Vue from "vue";
import VueI18n from "vue-i18n";
import axios from "axios";

Vue.use(VueI18n);

const availableLocales = ["nl", "en", "zh"];

export const availableLanguages = [
  { label: "Nederlands", value: "nl" },
  { label: "English", value: "en" },
  { label: "中文", value: "zh" }
];

export function updateI18nLocale(i18nRoot, language, store = null) {
  localStorage.setItem("locale", language);
  const newLocale = getLocale();

  // Load the new locale messages if not already loaded
  loadLocaleMessage(newLocale, store).then(messages => {
    if (messages) {
      i18nRoot.setLocaleMessage(newLocale, messages);
    }
    i18nRoot.locale = newLocale;
  });
}

function getLocale() {
  const navigatorLanguage = navigator.language.trim().split(/[-_]/)[0];
  const localStorageLanguage = localStorage.getItem("locale");

  if (
    localStorage.getItem("locale") !== "" &&
    availableLocales.includes(localStorageLanguage)
  ) {
    return localStorageLanguage;
  }

  if (availableLocales.includes(navigatorLanguage)) {
    return navigatorLanguage;
  }

  return process.env.VUE_APP_I18N_FALLBACK_LOCALE || "en";
}

async function loadLocaleMessage(locale, store = null) {
  try {
    let response;
    if (store && store.getters["network/getApiUrl"]) {
      response = await axios.get(
        `${store.getters["network/getApiUrl"]}/api/v2/translation/measure/${locale}`
      );
    } else {
      response = await axios.get(
        `${process.env.VUE_APP_API_URL}/api/v2/translation/measure/${locale}`
      );
    }
    return response.data;
  } catch (error) {
    return null;
  }
}

async function loadLocaleMessages(store = null) {
  const messages = {};

  // Load all locales in parallel
  const loadPromises = availableLocales.map(async locale => {
    const localeMessages = await loadLocaleMessage(locale, store);
    if (localeMessages) {
      messages[locale] = localeMessages;
    }
    return { locale, messages: localeMessages };
  });

  try {
    await Promise.all(loadPromises);
  } catch (error) {
    console.error("Error loading some locale messages:", error);
  }

  return messages;
}

export async function createI18n(store = null) {
  const messages = await loadLocaleMessages(store);

  return new VueI18n({
    locale: getLocale(),
    fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "en",
    messages
  });
}

const i18n = new VueI18n({
  locale: getLocale(),
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "en",
  messages: {} // Empty initially
});

export default i18n;
